
export default {
  data() {
    return {
      clearMarginTop: true
    }
  },
  methods: {
    goRefresh(val) {
      // this.$router.push({ name: 'distributor-aboutUs', query: { type: val } })
      let { href } = this.$router.resolve({
        name: "distributor-aboutUs",
        query: { type: val }
      });
      window.open(href)
      // if (this.$route.name === 'distributor-aboutUs') {
      //   setTimeout(() => {
      //     this.$router.go(0);
      //   }, 200)
      // }
    },
    goIssue(val) {
      let { href } = this.$router.resolve({
        name: "distributor-FAQ",
        query: { type: val }
      });
      window.open(href)
    },
    goContacts(val) {
      let { href } = this.$router.resolve({
        name: "distributor-contactUs",
        query: { type: val }
      });
      window.open(href)
    }
  },
  watch: {
    $route: {
      handler: function (newValue, oldValue) {
        if (!newValue.meta.footer_margin_none && newValue.name !== 'distributor-train-front-home' && newValue.name !== 'distributor-train-front-pay-success') {
          this.clearMarginTop = false;
        } else {
          this.clearMarginTop = true
        }
      },
      deep: true,
    }
  },
  created() {
    if (!this.$route.meta.footer_margin_none && this.$route.name !== 'distributor-train-front-home' && this.$route.name !== 'distributor-train-front-pay-success') {
      this.clearMarginTop = false;
    } else {
      this.clearMarginTop = true
    }
  }
}
